module.exports = __webpack_public_path__ + "e14cb48c8cb278cfa00487d1c99e46a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-17.png
// module id = 1971
// module chunks = 0